export const ENMonthWorkspace = {
	"1": "January",
	"2": "February",
	"3": "March",
	"4": "April",
	"5": "May",
	"6": "June",
	"7": "July",
	"8": "August",
	"9": "September",
	"10": "October",
	"11": "November",
	"12": "December"
};

export const BRMonthWorkspace = {
	"1": "Janeiro",
	"2": "Fevereiro",
	"3": "Março",
	"4": "Abril",
	"5": "Maio",
	"6": "Junho",
	"7": "Julho",
	"8": "Agosto",
	"9": "Setembro",
	"10": "Outubro",
	"11": "Novembro",
	"12": "Dezembro"
};
